const data = [
  // {
  //   name: "House N. 16-2",
  //   year: 0,
  //   location: "",
  //   story: 0,
  //   photo: 12,
  //   portrait: false,
  // },
  {
    name: "Church Extention N. 1",
    year: 0,
    location: "",
    story: 0,
    photo: 12,
    portrait: false,
  },
  {
    name: "House N. 39",
    year: 0,
    location: "",
    story: 0,
    photo: 8,
    portrait: true,
  },
  {
    name: "Office Building N. 6",
    year: 0,
    location: "",
    story: 0,
    photo: 12,
    portrait: true,
  },
  {
    name: "Office Building N. 4",
    year: 0,
    location: "",
    story: 0,
    photo: 8,
    portrait: true,
  },
  {
    name: "Office Building N. 5",
    year: 0,
    location: "",
    story: 0,
    photo: 19,
    portrait: true,
  },
  {
    name: "House N. 36",
    year: 2016,
    location: "Yangyang-si",
    story: 2,
    photo: 25,
    portrait: false,
  },
  {
    name: "House N. 27",
    year: 2016,
    location: "Yangyang-si",
    story: 2,
    photo: 32,
    portrait: false,
  },
  {
    name: "Maronie Pension",
    year: 2007,
    location: "Taean-gun",
    story: 3,
    photo: 15,
    portrait: true,
  },
  {
    name: "House N. 11",
    year: 2013,
    location: "Bundang-gu",
    story: 3,
    photo: 8,
    portrait: false,
  },
  {
    name: "House N. 34",
    year: 2014,
    location: "Pangyo",
    story: 2,
    photo: 6,
    portrait: true,
  },
  {
    name: "Commercial Facilities N. 4",
    year: 2016,
    location: "Yangji-myeon",
    story: 3,
    photo: 12,
    portrait: true,
  },
  {
    name: "House N. 29",
    year: 2016,
    location: "Icheon-si",
    story: 2,
    photo: 14,
    portrait: false,
  },
  {
    name: "House N. 18",
    year: 2014,
    location: "Pangyo",
    story: 3,
    photo: 10,
    portrait: false,
  },
  {
    name: "House N. 1",
    year: 2006,
    location: "Uiwang-si",
    story: 3,
    photo: 10,
    portrait: true,
  },
  {
    name: "House N. 3",
    year: 2010,
    location: "Pangyo",
    story: 3,
    photo: 12,
    portrait: false,
  },
  {
    name: "Office Building N. 2",
    year: 2015,
    location: "Yangjae-dong",
    story: 6,
    photo: 10,
    portrait: true,
  },
  {
    name: "House N. 4",
    year: 2011,
    location: "Pangyo",
    story: 3,
    photo: 14,
    portrait: true,
  },
  {
    name: "House N. 26",
    year: 2015,
    location: "Pangyo",
    story: 3,
    photo: 9,
    portrait: false,
  },
  {
    name: "House N. 7",
    year: 2012,
    location: "Pangyo",
    story: 2,
    photo: 19,
    portrait: false,
  },
  {
    name: "House N. 9",
    year: 2012,
    location: "Pangyo",
    story: 3,
    photo: 10,
    portrait: false,
  },
  {
    name: "House N. 17",
    year: 2014,
    location: "Pangyo",
    story: 3,
    photo: 11,
    portrait: false,
  },
  {
    name: "House N. 13",
    year: 2013,
    location: "Pangyo",
    story: 3,
    photo: 12,
    portrait: false,
  },
  {
    name: "House N. 32",
    year: 2017,
    location: "Pangyo",
    story: 3,
    photo: 9,
    portrait: true,
  },
  {
    name: "House N. 33",
    year: 2017,
    location: "Pangyo",
    story: 4,
    photo: 12,
    portrait: false,
  },
  {
    name: "House N. 31",
    year: 2017,
    location: "Pangyo",
    story: 3,
    photo: 9,
    portrait: true,
  },
  {
    name: "House N. 23",
    year: 2015,
    location: "Pangyo",
    story: 3,
    photo: 23,
    portrait: false,
  },
  {
    name: "House N. 37",
    year: 2014,
    location: "Pangyo",
    story: 2,
    photo: 7,
    portrait: true,
  },
  {
    name: "House N. 28",
    year: 2016,
    location: "Pangyo",
    story: 2,
    photo: 8,
    portrait: false,
  },
  {
    name: "House N. 24",
    year: 2015,
    location: "Gogi-dong",
    story: 2,
    photo: 10,
    portrait: false,
  },
  {
    name: "Commercial Facilities N. 2",
    year: 2014,
    location: "Pangyo",
    story: 9,
    photo: 5,
    portrait: true,
  },
  {
    name: "Commercial Facilities N. 5",
    year: 2017,
    location: "Pangyo",
    story: 9,
    photo: 5,
    portrait: true,
  },
  {
    name: "Office Building N. 3",
    year: 2016,
    location: "Yongin-si",
    story: 4,
    photo: 11,
    portrait: false,
  },
  {
    name: "House N. 30",
    year: 2017,
    location: "Pangyo",
    story: 2,
    photo: 8,
    portrait: true,
  },
  {
    name: "Summer House N. 2",
    year: 2008,
    location: "Gonjiam",
    story: 2,
    photo: 11,
    portrait: false,
  },
  {
    name: "Shop House N. 1",
    year: 2013,
    location: "Pangyo",
    story: 3,
    photo: 6,
    portrait: false,
  },
  {
    name: "Commercial Facilities N. 3",
    year: 2015,
    location: "Cheongdam-dong",
    story: 8,
    photo: 6,
    portrait: true,
  },
  {
    name: "Shop House N. 2",
    year: 2015,
    location: "Wirye-si",
    story: 4,
    photo: 12,
    portrait: true,
  },
  // {
  //   name: "House N. 16",
  //   year: 2013,
  //   location: "Gogi-dong",
  //   story: 3,
  //   photo: 8,
  //   portrait: false,
  // },
  {
    name: "House N. 16-2",
    year: 0,
    location: "",
    story: 0,
    photo: 12,
    portrait: false,
  },
  {
    name: "House N. 15",
    year: 2013,
    location: "Gyongju-si",
    story: 3,
    photo: 8,
    portrait: false,
  },
  {
    name: "House N. 10",
    year: 2013,
    location: "Pangyo",
    story: 3,
    photo: 10,
    portrait: false,
  },
  {
    name: "House N. 12",
    year: 2013,
    location: "Pangyo",
    story: 3,
    photo: 9,
    portrait: false,
  },
  {
    name: "House N. 19",
    year: 2014,
    location: "Pangyo",
    story: 3,
    photo: 12,
    portrait: false,
  },
  {
    name: "House N. 6",
    year: 2012,
    location: "Pangyo",
    story: 3,
    photo: 15,
    portrait: false,
  },
  {
    name: "Munsan Church",
    year: 2008,
    location: "Paju-si",
    story: 5,
    photo: 6,
    portrait: true,
  },
  {
    name: "Seosomun Church, Discipline center",
    year: 2009,
    location: "Gapyeong-gun",
    story: 2,
    photo: 9,
    portrait: false,
  },
  {
    name: "Namoonjae Pension",
    year: 2011,
    location: "West sea, island",
    story: 2,
    photo: 9,
    portrait: false,
  },
  {
    name: "Commercial Facilities N. 6",
    year: 0,
    location: "",
    story: 0,
    photo: 6,
    portrait: true,
  },
  {
    name: "Commercial Facilities N. 1",
    year: 2007,
    location: "",
    story: 4,
    photo: 6,
    portrait: true,
  },
  {
    name: "House N. 22",
    year: 0,
    location: "",
    story: 1,
    photo: 2,
    portrait: false,
  },
  {
    name: "House N. 5",
    year: 2011,
    location: "Pangyo",
    story: 3,
    photo: 5,
    portrait: false,
  },
  {
    name: "House N. 25",
    year: 2015,
    location: "Pangyo",
    story: 2,
    photo: 5,
    portrait: false,
  },
  {
    name: "House N. 35",
    year: 0,
    location: "Pangyo",
    story: 0,
    photo: 3,
    portrait: false,
  },
  {
    name: "House N. 20",
    year: 2014,
    location: "Pangyo",
    story: 3,
    photo: 2,
    portrait: true,
  },
  {
    name: "Nodeul island, Opera House",
    year: 2005,
    location: "Nodeul island, Seoul",
    story: 3,
    photo: 3,
    portrait: false,
  },
  {
    name: "Gallery",
    year: 0,
    location: "",
    story: 0,
    photo: 92,
    portrait: false,
  },
];
export default data;
